import React from 'react'
import {Button, Header, Input, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import { createUserLog } from '../../lib/api';
import {useSelector} from "react-redux";

const PPOperationMacro =({title, channel, description, option, data, isOperationModeCopied, setIsOperationModeCopied, parentcallback}) => {

    const [open,setOpen]= React.useState(false);
    const [firstOpen, setFirstOpen] = React.useState(false);
    const [secondOpen, setSecondOpen] = React.useState(false);
    const [thirdOpen, setThirdOpen] = React.useState(false);
    const [pwdisp, setPwdisp]= React.useState('');
    const [pwfac, setPwfact]= React.useState('');
    const [pwfmsg, setPwfmsg]= React.useState('');
    const [opdata, setOPdata]= React.useState('');
    const [radioopdata, setRadioOpData] = React.useState([]);
    const [pwdispflag, setpwdispflag] = React.useState(false);
    const [pwfacflag, setfacflag] = React.useState(false);
    const [pwerror, setpwerror] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    let powfactor, powdispatch;

    React.useEffect(() => {

        if(typeof data !== 'undefined' && data.length !== 0 && !isOperationModeCopied){
            if(!isOperationModeCopied){
                radioopdata.length = 0;
            }
            if(radioopdata.length === 0 && !isOperationModeCopied){
                radioopdata.push({'tag_id': 5555,'name': 'OPERIN_IDLE', 'tag_value': data[5555]});
                radioopdata.push({'tag_id': 5558,'name': 'OPERIN_LOADSHARE', 'tag_value': data[5558]});
                radioopdata.push({'tag_id': 5556, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': data[5556]});
                radioopdata.push({'tag_id': 5557, 'name': 'OPERIN_GRIDIND', 'tag_value': data[5557]});
                setRadioOpData(radioopdata);
                setIsOperationModeCopied(true);
            }
        }
    }, [data]);

    const handleOpen = () => setOpen( true);
    const handleClose = () => setOpen( false);

    const handlePPStart =(event, {id}) => {
        event.preventDefault();
        var seqdata =   {'buttonClickType': 'RESET PCS MAIN'};
        socket.emit('button click', seqdata);
        setSecondOpen(true);
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ type: "Reset PCS MAIN" }),
            };
            createUserLog({ log }).catch(console.error);
        }
    }

    const handleConf =(event) => {
        event.preventDefault();
        var seqdata =   {'buttonClickType': channel};
        socket.emit('button click', seqdata);
        setOpen( false);
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ type: channel }),
            };
            createUserLog({ log }).catch(console.error);
        }
    }

    let powFactorLimit = 0.85;
    let powFactorneg = -0.85;
    // let powerRating = (HP === 1) ? 460 : 440; //powerRating for PAFC
    let powerRating = 300; // update SOFC, change powerRating value by sumin, 240320

    const handleModal =() => {
        setThirdOpen(false);
        setSecondOpen(true);
        setpwdispflag(false);
        setFirstOpen(true);
    }

    const handleModalClose =() => {
        setThirdOpen(false);
        setSecondOpen(false);
        setFirstOpen(false);
    }

    const handleOK = () => {
        powfactor = (typeof pwfac === 'undefined' || pwfac === '') ? data[3158] : pwfac;        // OPERIN_POWFACT
        powdispatch = (typeof pwdisp === 'undefined' || pwdisp === '') ? data[3157] : pwdisp;   // OPERIN_SETPOWER
        let dispKWValRaw = powdispatch;
        if(powdispatch < 9.9999 || powdispatch > powerRating){
            setSecondOpen(true);
            setpwdispflag(true);
        }
        if (dispKWValRaw >= 10 && dispKWValRaw <= powerRating) {
            if (dispKWValRaw <= 452) {
                powFactorLimit = 0.85;
                powFactorneg = -0.85;
            } else if (dispKWValRaw <= 453) {
                powFactorLimit = 0.852;
                powFactorneg = -0.852;
            } else if (dispKWValRaw <= 455) {
                powFactorLimit = 0.855;
                powFactorneg = -0.855;
            } else if (dispKWValRaw <= 456) {
                powFactorLimit = 0.857;
                powFactorneg = -0.857;
            } else if (dispKWValRaw <= 457) {
                powFactorLimit = 0.859;
                powFactorneg = -0.859;
            } else if (dispKWValRaw <= 458) {
                powFactorLimit = 0.861;
                powFactorneg = -0.861;
            } else if (dispKWValRaw <= 459) {
                powFactorLimit = 0.863;
                powFactorneg = -0.863;
            } else {
                powFactorLimit = 0.865;
                powFactorneg = -0.865;
            }

            if (pwerror || (powfactor < powFactorLimit && (Math.sign(powfactor) === 1)) ||
                (powfactor > powFactorneg && (Math.sign(powfactor) === -1))) {
                setThirdOpen(true);
                setPwfmsg(powFactorLimit);
                setfacflag(true);
            } else {
                var kwdata = null;
                switch (opdata) {
                    case 5556: // OPERIN_GRIDCONNECT
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 3158, 'tag_value': powfactor},
                                {'tag_id': 3157, 'tag_value': powdispatch}, {
                                    'tag_id': 5555,
                                    'tag_value': 0
                                }, {'tag_id': 5558, 'tag_value': 0}, {'tag_id': 5556, 'tag_value': 1},
                                {'tag_id': 5557, 'tag_value': 0}, {'tag_id': 5548, 'tag_value': 1}] //10329 : AINPCS_STATUSWORD2_OVRFLAG
                        };
                        break;
                    case 5557:
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 3158, 'tag_value': powfactor},
                                {'tag_id': 3157, 'tag_value': powdispatch}, {
                                    'tag_id': 5555,
                                    'tag_value': 0
                                }, {'tag_id': 5558, 'tag_value': 0}, {'tag_id': 5556, 'tag_value': 0},
                                {'tag_id': 5557, 'tag_value': 1}, {'tag_id': 5548, 'tag_value': 1}]
                        };
                        break;
                    case 5555:
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 3158, 'tag_value': powfactor},
                                {'tag_id': 3157, 'tag_value': powdispatch}, {
                                    'tag_id': 5555,
                                    'tag_value': 1
                                }, {'tag_id': 5558, 'tag_value': 0}, {'tag_id': 5556, 'tag_value': 0},
                                {'tag_id': 5557, 'tag_value': 0}, {'tag_id': 5548, 'tag_value': 1}]
                        };
                        break;
                    case 5558:
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 3158, 'tag_value': powfactor},
                                {'tag_id': 3157, 'tag_value': powdispatch}, {
                                    'tag_id': 5555,
                                    'tag_value': 0
                                }, {'tag_id': 5558, 'tag_value': 1}, {'tag_id': 5556, 'tag_value': 0},
                                {'tag_id': 5557, 'tag_value': 0}, {'tag_id': 5548, 'tag_value': 1}]
                        };
                        break;
                    default:
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 3158, 'tag_value': powfactor},
                                {'tag_id': 3157, 'tag_value': powdispatch}, {
                                    'tag_id': 5555,
                                    'tag_value': 1
                                }, {'tag_id': 5558, 'tag_value': 0}, {'tag_id': 5556, 'tag_value': 0},
                                {'tag_id': 5557, 'tag_value': 0}, {'tag_id': 5548, 'tag_value': 1}]
                        };
                        break;

                }
                socket.emit('button click', kwdata);
                setSecondOpen(false);
                setFirstOpen(false);
                parentcallback(true);
                if (!electronApp) {
                    let log = {
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: null,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({
                            tag_id: kwdata.tags,
                            type: kwdata.buttonClickType,
                        }),
                    };
                    createUserLog({ log }).catch(console.error);
                }
                setPwdisp('');
                setPwfact('');
            }
        } else {
            setThirdOpen(true);
        }
    }

    const handlePFactChange = (event, value) => {
        event.preventDefault();
        if(event.target.value < 0.85 && (Math.sign(event.target.value) === 1)){
            setPwfact(0.85);
            setpwerror(true);
        }
        else if(event.target.value >1.001 && (Math.sign(event.target.value) === 1)){
            setPwfact(Number(1.0).toFixed(1));
            setpwerror(true);
        }
        else if(event.target.value > -0.85 && (Math.sign(event.target.value) === -1)){
            setPwfact(-0.85);
            setpwerror(true);
        }
        else if(event.target.value <= -0.99999 && (Math.sign(event.target.value) === -1)){
            setPwfact(-0.99999);
            setpwerror(true);
        }
        else {
            setPwfact(event.target.value);
            setpwerror(false);
        }
    }

    const handlePwChange = (event, value) => {
        event.preventDefault();
        setPwdisp(event.target.value);
    }

    const handleCheck = (event, {id}) => {
        switch(id) {
            case 'IDLE':
                setOPdata(5555);
                setRadioOpData([{'tag_id':5555, 'name': 'OPERIN_IDLE', 'tag_value': 1}, {'tag_id':5558, 'name': 'OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':5556, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':5557, 'name': 'OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'LOADSHARE':
                setOPdata(5558);
                setRadioOpData([{'tag_id':5555, 'name': 'OPERIN_IDLE', 'tag_value': 0}, {'tag_id':5558, 'name': 'OPERIN_LOADSHARE', 'tag_value': 1}, {'tag_id':5556, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':5557, 'name': 'OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'GRIDCONN':
                setOPdata(5556);
                setRadioOpData([{'tag_id':5555, 'name': 'OPERIN_IDLE', 'tag_value': 0}, {'tag_id':5558, 'name': 'OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':5556, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 1}, {'tag_id':5557, 'name': 'OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'GRIDIND':
                setOPdata(5557);
                setRadioOpData([{'tag_id':5555, 'name': 'OPERIN_IDLE', 'tag_value': 0}, {'tag_id':5558, 'name': 'OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':5556, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':5557, 'name': 'OPERIN_GRIDIND', 'tag_value': 1}]);
                break;
            default:
                setOPdata(5555);
                setRadioOpData([{'tag_id':5555, 'name': 'OPERIN_IDLE', 'tag_value': 1}, {'tag_id':5558, 'name': 'OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':5556, 'name': 'OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':5557, 'name': 'OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
        }
    }

    return (
        <div>
            {option === 1 ?
                <>
                    <Button onClick={() => setFirstOpen(true)} color ='blue' width='150px' >{title}</Button>
                    <Modal
                        onClose={() => setFirstOpen(false)}
                        onOpen={() => setFirstOpen(true)}
                        open={firstOpen}
                    >
                        <Modal.Header>START POWERPLANT</Modal.Header>
                        <Modal.Description style={styles.header}>
                            <Header> {description}</Header>
                        </Modal.Description>
                        <Modal.Description>
                            <Header color ='red' style={styles.header1}>RESET PCS MAIN</Header>
                            <Header style={{marginLeft: '15px'}}> Do you wish to Reset PCS Faults (MAIN)?</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id = '1'
                                    content='OK'
                                    onClick={handlePPStart}
                            />
                            <Button color={'red'}
                                    size='small'
                                    id = '2'
                                    content='Cancel'
                                    onClick={() => setFirstOpen(false)}
                            />
                        </Modal.Actions>
                        <Modal
                            onClose={() => setSecondOpen(false)}
                            open={secondOpen}
                            size='small'
                        >
                            <Modal.Header>POWER PLANT SETUP</Modal.Header>
                            <Modal.Description style = {{align: 'left'}}>
                                <Header style={styles.header}> OPERATION MODE</Header>
                            </Modal.Description>
                            <Modal.Content>
                                <Input
                                    type='radio'
                                    id='IDLE'
                                    label='IDLE'
                                    checked={(radioopdata.length > 0) ? radioopdata.find(el => el.name === 'OPERIN_IDLE').tag_value === 1 : false}
                                    onChange={handleCheck}
                                    style={styles.checkbox}
                                />
                                <Input
                                    type='radio'
                                    id='LOADSHARE'
                                    disabled
                                    label='LOADSHARE'
                                    checked={(radioopdata.length > 0) ? radioopdata.find(el => el.name === 'OPERIN_LOADSHARE').tag_value === 1 : false}
                                    onChange={handleCheck}
                                    style={styles.checkbox}
                                />
                                <Input
                                    type='radio'
                                    id='GRIDCONN'
                                    label='GRID CONNECT'
                                    checked={(radioopdata.length > 0) ? radioopdata.find(el => el.name === 'OPERIN_GRIDCONNECT').tag_value === 1 : false}
                                    onChange={handleCheck}
                                    style={styles.checkbox}
                                />
                                <Input
                                    type='radio'
                                    id='GRIDIND'
                                    label='GRID INDEPENDENT'
                                    checked={(radioopdata.length > 0) ? radioopdata.find(el => el.name === 'OPERIN_GRIDIND').tag_value === 1 : false}
                                    onChange={handleCheck}
                                    style={styles.checkbox}
                                />
                                <Modal.Description style = {{align: 'right'}}>
                                    <Header style={styles.header}> POWER DISPATCH</Header>
                                </Modal.Description>
                                <Modal.Content>
                                    <Modal.Description>
                                        <Header style={styles.header}> SET POWER </Header>
                                        <form autoComplete='off' style={styles.input}>
                                            <Input focus placeholder={data[3157]}
                                                   name='Input change'
                                                   type='number'
                                                   step ='0.0001'
                                                   size='small'
                                                   min ='1'
                                                   max ='300'
                                                   onChange={(event, value) => handlePwChange(event, value)}
                                                   defaultValue={data[3157]}
                                            />
                                            {/** //update SOFC, change min/max Value 0~460 -> 1~300 **/ }
                                        </form>
                                    </Modal.Description>
                                    <Modal.Description>
                                        <Header style={styles.header}> SET POWER FACTOR</Header>
                                        <form autoComplete='off' style={styles.input}>
                                            <Input focus placeholder={data[3157]}
                                                   name='Input change'
                                                   type='number'
                                                   step ='0.0001'
                                                   max = '1.0'
                                                   size='small'
                                                   onChange={(event, value) => handlePFactChange(event, value)}
                                                   defaultValue={data[3158] === 1 ? Number(1.0).toFixed(1) : data[3158]}
                                            />
                                        </form>
                                    </Modal.Description>
                                </Modal.Content>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button color={'green'}
                                        size='small'
                                        id='1'
                                        content='OK'
                                        onClick={handleOK}
                                />
                                <Button color={'red'}
                                        size='small'
                                        id='2'
                                        content='Cancel'
                                        onClick={handleModalClose}
                                />
                            </Modal.Actions>
                        </Modal>
                        { pwdispflag ?
                            <Modal
                                onClose={() => setThirdOpen(false)}
                                open={thirdOpen}
                                size='small'
                            >
                                <Modal.Header>OUT OF RANGE</Modal.Header>
                                <Modal.Description>
                                    <Header style={styles.header}> The Acceptable Range for Power Dispatch is
                                        1 to {powerRating}</Header>
                                </Modal.Description>
                                <Modal.Actions>
                                    <Button color={'green'}
                                            size='small'
                                            id='1'
                                            content='OK'
                                            onClick={handleModal}
                                    />
                                    <Button color={'red'}
                                            size='small'
                                            id='2'
                                            content='Cancel'
                                            onClick={handleModalClose}
                                    />
                                </Modal.Actions>
                            </Modal>
                            :
                            <Modal
                                onClose={() => setThirdOpen(false)}
                                open={thirdOpen}
                                size='small'
                            >
                                <Modal.Header>OUT OF RANGE</Modal.Header>
                                <Modal.Description>
                                    <Header style={styles.header}> The Acceptable Range for Power Factor Dispatch is
                                        {'+/-' + pwfmsg} to 1.0</Header>
                                </Modal.Description>
                                <Modal.Actions>
                                    <Button color={'green'}
                                            size='small'
                                            id='1'
                                            content='OK'
                                            onClick={handleModal}
                                    />
                                    <Button color={'red'}
                                            size='small'
                                            id='2'
                                            content='Cancel'
                                            onClick={handleModalClose}
                                    />
                                </Modal.Actions>
                            </Modal>
                        }
                    </Modal>
                </>
                :
                option === 2 ? // 'Start PP', Cannot Start or re-start powerplant from ~ 
                    <Modal trigger={<Button color='blue' style={{marginBottom : '5px'}} >{title} </Button>}
                           style={styles.toggle}
                           open={open}
                           onClose={handleClose}
                           onOpen={handleOpen}>
                        <Modal.Header>START POWERPLANT</Modal.Header>
                        <Modal.Description>
                            <Header style={styles.header}> {description}</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id='1'
                                    content='OK'
                                    onClick={handleClose}
                            />
                            <Button color={'red'}
                                    size='small'
                                    id='2'
                                    content='Cancel'
                                    onClick={handleClose}
                            />
                        </Modal.Actions>
                    </Modal>
                    :
                    <Modal trigger={<Button color='blue' style={{marginBottom : '5px'}}>{title} </Button> /**Clear  */} 
                           style={styles.toggle}
                           open={open}
                           onClose={handleClose}
                           onOpen={handleOpen}>
                        <Modal.Header>Confirmation</Modal.Header>
                        <Modal.Description>
                            <Header style={styles.header}> {description}</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id='1'
                                    content='OK'
                                    onClick={handleConf}
                            />
                            <Button color={'red'}
                                    size='small'
                                    id='2'
                                    content='Cancel'
                                    onClick={handleClose}
                            />
                        </Modal.Actions>
                    </Modal>
            }
        </div>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    toggle: {
        maxWidth: '500px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '15px',
        marginBottom: '10px'
    },
    header1: {
        marginTop: '20px',
        marginLeft: '15px'
    },
    checkbox: {
        flexDirection: 'row-reverse',
        marginRight: '40px',
        marginBottom: '5px'
    }
}

export default PPOperationMacro;